import _ from 'lodash';
import update from 'immutability-helper';
import classNames from 'classnames';
import objectAssign from 'object-assign';
import FlipMove from 'react-flip-move';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withRouter } from 'react-router';
import * as actions from '../../actions/eventActions';
// import Button from '../../../components/common/Button';
// import { Link } from 'react-router';
// import HeaderImage from '../../../components/common/HeaderImage';
import RichTextInput from '../../components/common/RichTextInput';
import TextInput from '../../components/common/TextInput';
import CheckboxInput from '../../components/common/CheckboxInput';
import SelectInput from '../../components/common/SelectInput';
import RichTextEditor from 'react-rte';
import FontAwesome from 'react-fontawesome';
// import * as utils from '../../../components/common/utils';
import ManageEventTeamCategory from './ManageEventTeamCategory';
// import toastr from 'toastr';

class ManageEventTeam extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.renderCategories = this.renderCategories.bind(this);
    this.updateField = this.updateField.bind(this);
    this.updateRichField = this.updateRichField.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    this.updateMemberPosition = this.updateMemberPosition.bind(this);
    this.addCategory = this.addCategory.bind(this);
    this.copyCategory = this.copyCategory.bind(this);
    this.addMemberCategory = this.addMemberCategory.bind(this);
    this.copyMemberCategory = this.copyMemberCategory.bind(this);
    this.removeMemberCategory = this.removeMemberCategory.bind(this);
    this.newID = this.newID.bind(this);
    // this.updateTimeField = this.updateTimeField.bind(this);
    // // this.updateRichField = this.updateRichField.bind(this);
    // this.askBeforeExit = this.askBeforeExit.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.delete = this.delete.bind(this);
    this.toggle = this.toggle.bind(this);
    // this.toggleSection = this.toggleSection.bind(this);
    // this.registeredCheckboxText = this.registeredCheckboxText.bind(this);
    this.state = {
      details: props.details,
      errors: {team_categories: []},
      deletedCategories: [],
      deletedMemberCategories: [],
      showTeam: false,
      richDescription: RichTextEditor.createValueFromString(
        (props.details.description || ''),
        'html'
      ),
    };
  }

  componentWillMount() {
    // this.props.router.setRouteLeaveHook(this.props.route, () => {
    //   if (!this.askBeforeExit()) {
    //     return false;
    //   }
    // });
  }

  componentWillReceiveProps(nextProps) {
    if(!_.isEqual(this.props.details, nextProps.details)) {
      this.setState({
        details: nextProps.details,
        errors: {team_categories: []},
      });
    }
    if(!_.isEqual(this.props.errors, nextProps.errors) &&
        nextProps.errors[this.props.details.identifier]) {
      this.setState({
        errors: nextProps.errors[this.props.details.identifier]
      });
    }
  }
  //
  // updateReverseBooleanField(event) {
  //   let details = objectAssign({}, this.state.details);
  //   details[event.target.name] = !event.target.checked;
  //   return this.setState({
  //     details: details
  //   });
  // }
  //
  renderCategories() {
    return this.state.details.team_categories.map((category, categoryIndex) => {
      let errors = _.get(this.state.errors, ['team_categories', categoryIndex], {});
      return (
        <ManageEventTeamCategory
          key={category.identifier}
          categoryIndex={categoryIndex}
          category={category}
          errors={errors}
          copyCategory={this.copyCategory}
          addMemberCategory={this.addMemberCategory}
          copyMemberCategory={this.copyMemberCategory}
          updatePosition={this.updatePosition}
          updateCategory={this.updateCategory}
          updateMemberPosition={this.updateMemberPosition}
          />
      );
    });
  }

  newID() {
    return '_' + Math.random().toString(36).substr(2, 20);
  }

  addCategory() {
    let cat = {
      errors:[],
      _destroy: false,
      member_categories: [],
      identifier: this.newID()
    }
    let details = update(this.state.details,
      {team_categories: {
          $push: [cat]
      }}
    );
    this.setState({
      details: details
    });
  }

  copyCategory(team) {
    function updateNested(items) {
      // console.log(items);
      return _.map(items, (item) => {
        return update(item, {
          "id": {$set: undefined},
          "identifier": {$set: '_' + Math.random().toString(36).substr(2, 20)},
        })
      })
    }

    function copiedName(item) {
      return item + ' (Kopi)';
    }

    // function updatePosition(item) {
    //   return item + 1;
    // }

    let newCategory = update(team, {
      "name": {$apply: copiedName},
      "id": {$set: undefined},
      "identifier": {$set: '_' + Math.random().toString(36).substr(2, 20)},
      "member_categories": {
        $apply: updateNested
      }
    });

    let details = update(this.state.details,
      {team_categories: {
          $push: [newCategory]
      }}
    );
    this.setState({
      details: details
    });
  }

  addMemberCategory(categoryIndex) {
    let details = update(this.state.details,
      {team_categories: {[categoryIndex]:
          {member_categories:
            {$push: [{errors:[],
              _destroy: false,
              identifier: this.newID()
            }]}
          }
      }}
    );
    this.setState({
      details: details
    });
  }

  copyMemberCategory(categoryIndex, team) {
    function copiedName(item) {
      return item + ' (Kopi)';
    }

    let newCategory = update(team, {
      "name": {$apply: copiedName},
      "id": {$set: undefined},
      "identifier": {$set: '_' + Math.random().toString(36).substr(2, 20)},
    });

    let details = update(this.state.details,
      {team_categories: {[categoryIndex]:
          {member_categories:
            {$push: [newCategory]}
          }
      }}
    );
    this.setState({
      details: details
    });
  }

  updateField(event) {
    let details = objectAssign({}, this.state.details);
    let value = event.target.type == 'checkbox' ? event.target.checked : event.target.value;
    details[event.target.name] = value;
    return this.setState({
      details: details
    });
  }

  updateRichField(field, value) {
    return this.setState({
      [field]: value
    });
  }

  updateCategory(category, index) {
    let details = update(this.state.details, {team_categories:
      {$splice: [[index, 1, category]]}
    });
    return this.setState({
      details: details
    });
  }

  updatePosition(fromP, toP) {
    let details = objectAssign({}, this.state.details);
    let teamCategories = objectAssign([], details.team_categories);
    teamCategories.splice(toP, 0, teamCategories.splice(fromP, 1)[0]);
    details.team_categories = teamCategories;
    return this.setState({
      details: details
    });
  }

  updateMemberPosition(categoryIndex, fromP, toP) {
    let memberCat = this.state.details.team_categories[categoryIndex].member_categories[fromP];
    let details = update(this.state.details, {team_categories: {
      [categoryIndex]: {member_categories: {
        $splice: [[fromP, 1]]
      }}}});
    details = update(details, {team_categories: {
      [categoryIndex]: {member_categories: {
        $splice: [[toP, 0, memberCat]]
      }}}});
    return this.setState({
      details: details
    });
  }

  removeMemberCategory(categoryIndex, memberIndex) {
    let details = update(this.state.details, {team_categories: {[categoryIndex]:
      {member_categories: {[memberIndex]:
        {_destroy: {$set: true},
         name: {$set: 'marked-destroy'}
       }}}}}
    );
    this.setState({
      details: details
    });
  }

  submitForm(e) {
    let details = objectAssign({}, this.state.details);
    details['description'] = this.state.richDescription.toString('html');
    if (this.props.details.id) {
      this.props.actions.updateTeam(details);
    } else {
      this.props.actions.createTeam(details);
    }
    e.preventDefault();
  }

  delete() {
    if (!confirm('Ønsker du å slette?')) {
      return false;
    }
    let details = objectAssign({}, this.state.details);
    this.props.actions.deleteTeam(details, this.props.teamIndex);
  }

  toggle(part) {
    this.setState({
      [part]: !this.state[part]
    });
  }

  // askBeforeExit() {
  //   let changed = !_.isEqual(this.props.details, this.state.details);
  //   if (changed && !confirm('Ønsker du å gå tilbake uten å lagre?')) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }
  //

  render() {
    return (
      <div className={classNames('panel panel-default')}>
        <div className="panel-heading" onClick={() => {
            this.toggle('showTeam');
          }}>
          <h4>
            {this.state.details.name || 'Gruppenavn'}
          </h4>
        </div>
        <div className={classNames('panel-body',
          {'hidden': !this.state.showTeam})}>
          <form onSubmit={this.submitForm}>
            <input className="hidden" type="submit" />
            <TextInput
              name="name"
              error={this.state.errors.name}
              inputClass="input-lg"
              placeholder="Navn på gruppering"
              onChange={this.updateField}
              value={this.state.details.name}
              />
            <TextInput
              name="slug"
              disabled={false}
              helpText={"Vises i adressefeltet til nettleseren og brukes \
                for å navigere. OBS! Dette feltet burde \
                ikke endres etter at registrering av deltagere har startet"}
              label="Url (url-handle)"
              error={this.state.errors.slug}
              onChange={this.updateField}
              value={this.state.details.slug}
              />
            <RichTextInput
              label="Instruksjoner for gruppering"
              name={'description'}
              richName={'richDescription'}
              error={this.state.errors.description}
              value={this.state.richDescription}
              onChange={this.updateRichField} />
            <CheckboxInput
              name="static_categories"
              fieldId={'static_categories' + this.state.details.identifier}
              helpText={"Dette feltet gjør at påmeldingsskjema alltid \
                inneholder en av hver kategori. Dette brukes når man for \
                eksempel skal fordele brukere på t-skjortestørrelser."}
              label="Statiske kategorier"
              error={this.state.errors.static_categories}
              onChange={this.updateField}
              checked={this.state.details.static_categories}
              value={'_'+this.state.details.static_categories}
              />
            <CheckboxInput
              name="unique_team_members"
              fieldId={'unique_team_members' + this.state.details.identifier}
              label="Maks 1 kategori pr deltager"
              error={this.state.errors.unique_team_members}
              onChange={this.updateField}
              checked={this.state.details.unique_team_members}
              value={'_'+this.state.details.unique_team_members}
              />
            <br/>
            <SelectInput
              label="Beregning av pris for medlemskategorier"
              name="member_price_scheme"
              value={this.state.details.member_price_scheme}
              optionsValue="value"
              optionsName="text"
              options={[{value: 'max', text: 'Maks'},
                        {value: 'min', text: 'Min'},
                        {value: 'sum', text: 'Totalt'}]}
              onChange={this.updateField}
              />
            <div className="page-header">
              <h4>Kategorier</h4>
            </div>
            <FlipMove duration="150" easing="cubic-bezier(0.420, 0.000, 0.580, 1.000)">
              {this.renderCategories()}
            </FlipMove>
            <button type="button"
              className="btn btn-default btn-block"
              onClick={this.addCategory}>
              {'Legg til kategori'}
            </button>
          </form>
        </div>
        <div className={classNames('panel-footer clearfix',
          {'hidden': !this.state.showTeam})}>
          <button className="btn btn-danger"
            disabled={this.state.loading}
            onClick={this.delete} >
            <FontAwesome name="trash" />
            {' Slett'}
          </button>
          &emsp;
          <span
            onClick={() => this.props.actions.copyTeam(this.props.details)}
            className={classNames('btn btn-default btn-small')}>
            <FontAwesome name="copy" />
          </span>
          <button className="btn btn-primary pull-right"
            disabled={this.state.loading}
            onClick={this.submitForm} >
            <FontAwesome name="save" />
            {' Lagre'}
          </button>
        </div>
      </div>
    );
  }
}

ManageEventTeam.propTypes = {
  actions: PropTypes.object.isRequired,
  teamIndex: PropTypes.number,
  details: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  teamList: PropTypes.array.isRequired,
  teamListUpdated: PropTypes.number,
  eventId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loading: state.events.loading,
    teamList: state.events.teamList,
    errors: state.events.teamErrors,
    teamListUpdated: state.events.teamListUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageEventTeam));



/** WEBPACK FOOTER **
 ** ./src/containers/events/ManageEventTeam.js
 **/